import { render, staticRenderFns } from "./DossierBrowseExtraButtonEditProperties.vue?vue&type=template&id=44f2de1e&"
import script from "./DossierBrowseExtraButtonEditProperties.vue?vue&type=script&lang=ts&"
export * from "./DossierBrowseExtraButtonEditProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f2de1e')) {
      api.createRecord('44f2de1e', component.options)
    } else {
      api.reload('44f2de1e', component.options)
    }
    module.hot.accept("./DossierBrowseExtraButtonEditProperties.vue?vue&type=template&id=44f2de1e&", function () {
      api.rerender('44f2de1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierBrowseExtraButtonEditProperties.vue"
export default component.exports